import { Component, type ErrorInfo, type ReactNode } from "react";
import { observability } from "@/lib/observability";
import { LGoButton } from "@/ui/branded";

interface Props {
  children: ReactNode;
}

interface State {
  hasCrashed: boolean;
}

// Without this, a render error unmounts the whole tree and the partner is left on a blank page
// with nothing to report.
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasCrashed: false };

  static getDerivedStateFromError(): State {
    return { hasCrashed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    observability.captureError(error, { componentStack: info.componentStack });
  }

  render() {
    if (!this.state.hasCrashed) return this.props.children;
    return (
      <div role="alert" className="flex min-h-screen items-center justify-center bg-background p-6">
        <div className="flex max-w-md flex-col items-center gap-4 text-center">
          <h1 className="font-display text-2xl font-semibold tracking-tight">Něco se pokazilo</h1>
          <p className="text-sm text-muted-foreground">
            Chybu jsme zaznamenali. Načtěte stránku znovu. Pokud se to opakuje, napište nám, co jste
            právě dělali.
          </p>
          <LGoButton onClick={() => window.location.reload()}>Načíst znovu</LGoButton>
        </div>
      </div>
    );
  }
}
